import {computed} from "mobx";
import {BaseModuleState} from "../../../../../infrastructure/models/base-module-state";
import {BaseMobxState} from "../../../../../infrastructure/mobx/base-mobx-state";
import {NavigationManager} from "../../../../../core/managers/navigation-manager";
import {AppStore} from "../../../../../core/app/app-store";
import {LoggerUtils} from "../../../../../infrastructure/utils/logger/logger-utils";
import {DatetimeUtils} from "../../../../../infrastructure/utils/datetime-utils";
import {DeviceViewModel} from "../../../../../core/models/device.view-model";
import {TermsUtils} from "../../../../../infrastructure/utils/terms-utils";
import {CompetitionHighlightsPageConfig} from "../competition-highlights-page.config";
import type {PartialGameDomainModel} from "../../../../../domain/partial-game/models/partial-game-domain-model";

export class CompetitionHighlightsPageState extends BaseModuleState {
  static injectables = [...BaseMobxState.injectables, NavigationManager, AppStore, LoggerUtils, DatetimeUtils, DeviceViewModel, TermsUtils, CompetitionHighlightsPageConfig];

  @computed get competitionId(): Number {
    return Number(this.currentLinkModel?.params.key.split('-')?.last())
  }

  @computed get page() {
    return this.currentLinkModel.params.page
  }

  @computed get gameContext(): PartialGameDomainModel {
    return this.appState.context.game
  }
}
